import {DeleteOutlined, PlusOutlined, PrinterFilled} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  Popconfirm,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
  message,
} from 'antd';
import {useEffect} from 'react';
import {fetchDieProfileDropdown} from '../../slices/die-profile';
import dayjs from 'dayjs';
import {useState} from 'react';
import 'react-phone-input-2/lib/style.css';
import {useDispatch, useSelector} from 'react-redux';
import {Link, useNavigate} from 'react-router-dom';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import {ReactComponent as Back} from '../../Images/Back.svg';
import {
  fetchAlloysList,
  resetAlloyList,
  resetCurrentAlloyListPage,
} from '../../slices/alloy';
import {
  fetchTempersList,
  resetCurrentTemperPage,
  resetTempersList,
} from '../../slices/tempers';
import {createNumberValidationRule} from '../../utils/CreateNumberValidationRule';
import {
  createExcessStock,
  deleteExcessStock,
  fetchExcessStockBundles,
  resetexcessStockList,
} from '../../slices/excess-stock';
const {Option} = Select;

function CreateExcessStock() {
  const {
    list: dieProfileList,
    loading: dieProfileLoading,
    currentPage: dieProfileCurrentPage,
    hasMore: dieProfileHasMore,
  } = useSelector(state => state.dieProfile);
  const {
    list: alloyList,
    loading: alloyLoading,
    currentPage: alloyCurrentPage,
    hasMore: alloyHasMore,
  } = useSelector(state => state.alloy);

  const {
    list: temperList,
    loading: temperLoading,
    currentPage: temperCurrentPage,
    hasMore: temperHasMore,
  } = useSelector(state => state.temper);
  const [form] = Form.useForm();

  const {user: currentUser} = useSelector(state => state.auth);
  const [btnLoading, setBtnLoading] = useState(false);
  const [searchGroup, setSearchGroup] = useState('');
  const [search, setSearch] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const dispatch = useDispatch();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchAlloy, setSearchAlloy] = useState('');
  const [searchTemper, setSearchTemper] = useState('');

  const {
    data = [],
    totalRecord,
    status,
  } = useSelector(state => state.excessStock);

  const [checkedList, setCheckedList] = useState([
    'SrNo',
    'bundle_inward__bundle_no',
    'die_profile__die_number',
    'itemName',
    'length',
    'pieces',
    'weight',
    'avg_weight',
    'bundle_inward__packing_date',
    'die_profile__die_diagram',
    'bundle_inward__status',
    'die_profile',
    'action',
  ]);

  useEffect(() => {
    dispatch(resetAlloyList());
    dispatch(fetchDieProfileDropdown({page: 1, pagesize: 5000}));
    dispatch(fetchAlloysList({page: 1, pagesize: 1000}));
    dispatch(fetchTempersList({page: 1, pagesize: 1000}));
  }, []);

  useEffect(() => {
    dispatch(
      fetchExcessStockBundles({
        page,
        pagesize,
        ...(search && {search: search}),
        ...(orderBy && {ordering: orderBy}),
      }),
    );
  }, [dispatch, page, pagesize, search, orderBy]);
  const handleDieProfileChange = (selected, value) => {
    if (!selected) {
      form.setFieldsValue({
        tool_number: null,
        die_type: null,
        total_running_qty: null,
        total_running_ton: null,
        current_kg: null,
      });
      setSearchGroup(null); // Reset searchGroup state to clear the selected value
      return;
    }
  };

  const onScrollDieProfile = async event => {
    const target = event.target;
    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(
        fetchDieProfileDropdown({page: dieProfileCurrentPage, pagesize: 5000}),
      );
    }
  };

  const handleSearchDieGroup = value => {
    setSearchGroup(value);
    if (value) {
      dispatch(
        fetchDieProfileDropdown({page: 1, pagesize: 1000, search: value}),
      );
    } else {
      dispatch(fetchDieProfileDropdown({page: 1, pagesize: 10}));
    }
  };

  const onScrollAlloy = async event => {
    const target = event.target;
    if (
      !alloyLoading &&
      alloyHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchAlloysList({page: alloyCurrentPage, pagesize: 10}));
    }
  };

  const handleChangeAlloy = value => {
    setSearchAlloy(value);
  };

  const handleSearchAlloy = value => {
    setSearchAlloy(value);
    if (value) {
      setSearchAlloy(value);
      dispatch(resetAlloyList());
      dispatch(fetchAlloysList({page: 1, pagesize: 100, search: value}));
    } else {
      setSearchAlloy('');
      dispatch(resetAlloyList());
      dispatch(resetCurrentAlloyListPage());
      dispatch(fetchAlloysList({page: 1, pagesize: 10}));
    }
  };

  const onScrollTemper = async event => {
    const target = event.target;
    if (
      !temperLoading &&
      temperHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchTempersList({page: alloyCurrentPage, pagesize: 10}));
    }
  };

  const handleChangeTemper = value => {
    setSearchTemper(value);
  };

  const handleSearchTemer = value => {
    if (value) {
      setSearchTemper(value);
      dispatch(resetTempersList());
      dispatch(fetchTempersList({page: 1, pagesize: 100, search: value}));
    } else {
      setSearchTemper('');
      dispatch(resetTempersList());
      dispatch(resetCurrentTemperPage());
      dispatch(fetchTempersList({page: 1, pagesize: 10}));
    }
  };


  const handleFinish = values => {
    setBtnLoading(true);

    dispatch(createExcessStock({values}))
      .unwrap()
      .then(result => {
        setBtnLoading(false);
        if (result.success) {
          message.success('Excess Stock Created Successfully!');
          form.resetFields(); // Reset form after successful submission
          dispatch(
            fetchExcessStockBundles({
              page,
              pagesize,
              ...(search && {search: search}),
              ...(orderBy && {ordering: orderBy}),
            }),
          );
        }
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  
  const [selectedShift, setSelectedShift] = useState('');

  const [shiftmode, setShiftMode] = useState(false);

  const getCurrentShift = () => {
    const now = dayjs().tz('Asia/Kolkata');

    const startA = now.set('hour', 8).set('minute', 0).set('second', 0); // 08:00 AM
    const endA = now.set('hour', 20).set('minute', 0).set('second', 0); // 08:00 PM

    if (now.isSameOrAfter(startA) && now.isBefore(endA)) {
      return 'A';
    }

    return 'B';
  };

  useEffect(() => {
    const currentShift = getCurrentShift();
    setSelectedShift(currentShift);
    form.setFieldsValue({
      shift: currentShift, // for example
    });
  }, []);

  const [shiftModes, setShiftModes] = useState([
    {title: 'A', value: 'A'},
    {title: 'B', value: 'B'},
  ]);
  const handleChangeShift = e => {
    setShiftMode(e);
  };

  const dataSource = data.map((item, index) => ({
    ...item,
    key: item.id || index,
    SrNo: (page - 1) * pagesize + index + 1,
  }));

 
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';

    if (sortField === 'pan_number' && sortOrder === 'ascend') {
      sortingEnumKey = 'pan_number';
    }
    if (sortField === 'pan_number' && sortOrder === 'descend') {
      sortingEnumKey = '-pan_number';
    }
    if (sortField === 'gstin_number' && sortOrder === 'ascend') {
      sortingEnumKey = 'gstin_number';
    }
    if (sortField === 'gstin_number' && sortOrder === 'descend') {
      sortingEnumKey = '-gstin_number';
    }
    if (sortField === 'udyam_no' && sortOrder === 'ascend') {
      sortingEnumKey = 'udyam_no';
    }
    if (sortField === 'udyam_no' && sortOrder === 'descend') {
      sortingEnumKey = '-udyam_no';
    }
    if (sortField === 'customer_name' && sortOrder === 'ascend') {
      sortingEnumKey = 'customer_name';
    }
    if (sortField === 'customer_name' && sortOrder === 'descend') {
      sortingEnumKey = '-customer_name';
    }
    if (sortField === 'phone_number' && sortOrder === 'ascend') {
      sortingEnumKey = 'phone_number';
    }
    if (sortField === 'phone_number' && sortOrder === 'descend') {
      sortingEnumKey = '-phone_number';
    }
    if (sortField === 'created_at' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_at';
    }
    if (sortField === 'created_at' && sortOrder === 'descend') {
      sortingEnumKey = '-created_at';
    }
    if (sortField === 'created_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_by';
    }
    if (sortField === 'created_by' && sortOrder === 'descend') {
      sortingEnumKey = '-created_by';
    }
    if (sortField === 'updated_at' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_at';
    }
    if (sortField === 'updated_at' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_at';
    }
    if (sortField === 'updated_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_by';
    }
    if (sortField === 'updated_by' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_by';
    }
    return sortingEnumKey;
  };
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
    setPageSize(pagination.pageSize);
  };

  const handlePageChange = newPage => {
    setPage(newPage);
    setOrderBy('');
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',

      width: '8%',
    },
    {
      title: 'Bundle No',
      dataIndex: 'bundle_inward__bundle_no',
      key: 'bundle_inward__bundle_no',

      render: bundle_inward__bundle_no => bundle_inward__bundle_no || 'N/A',
    },
    {
      title: 'Profile',
      dataIndex: 'die_profile__die_number',
      key: 'die_profile__die_number',

      render: die_profile__die_number => die_profile__die_number || 'N/A',
    },
    {
      title: 'Profile Image',
      dataIndex: 'die_profile__die_diagram',
      key: 'die_profile__die_diagram',
      width: 100,
      render: die_profile__die_diagram => {
        const fileUrl = die_profile__die_diagram;

        // Check: no file or not a valid URL starting with http/https
        if (
          !fileUrl ||
          (!fileUrl.startsWith('http://') && !fileUrl.startsWith('https://'))
        ) {
          return (
            <div style={{width: '70px', height: '70px'}}></div> // blank space
          );
        }

        const fileExtension = fileUrl.split('.').pop().toLowerCase();

        if (fileExtension === 'pdf') {
          return (
            <Button
              type="link"
              style={{padding: '0px'}}
              onClick={async () => {
                try {
                  const response = await fetch(fileUrl);
                  if (!response.ok)
                    throw new Error(`HTTP error! Status: ${response.status}`);
                  const blobData = await response.blob();
                  const blob = new Blob([blobData], {type: 'application/pdf'});
                  const blobURL = URL.createObjectURL(blob);
                  window.open(blobURL);
                } catch (error) {
                  console.error('Error opening PDF:', error);
                }
              }}
            >
              View PDF
            </Button>
          );
        } else if (
          ['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(fileExtension)
        ) {
          return (
            <img
              width="70"
              src={fileUrl}
              alt="Die Diagram"
              style={{objectFit: 'contain', maxHeight: '100%'}}
            />
          );
        } else {
          return <div style={{width: '70px', height: '70px'}}></div>; // blank space for unsupported types too
        }
      },
    },

    {
      title: 'Profile Description',
      dataIndex: 'die_profile',
      key: 'itemName',

      render: (text, record) => {
        const dimensions = [
          record?.die_profile__dimension1,
          record?.die_profile__dimension2,
          record?.die_profile__dimension3,
          record?.die_profile__dimension4, // if it exists
        ]
          .map((dim, index) => {
            if (dim === null || dim === '' || dim === undefined) return null;

            const fixed = Number(dim).toFixed(2);
            if ((index === 2 || index === 3) && fixed === '0.00') return '';
            return fixed;
          })
          .filter(dim => dim !== null && dim !== '');

        if (dimensions.length === 0) return <span>N/A</span>;

        return <div>{dimensions.join(' X ')}</div>;
      },
    },
    {title: 'Length', dataIndex: 'length', key: 'length'},
    {title: 'Pieces', dataIndex: 'pieces', key: 'pieces'},
    {title: 'Weight', dataIndex: 'weight', key: 'weight'},
    {
      title: 'Avg Weight',
      dataIndex: 'avg_weight',
      key: 'avg_weight',
    },
    {
      title: 'Packing Date',
      dataIndex: 'bundle_inward__packing_date',
      key: 'bundle_inward__packing_date',

      render: bundle_inward__packing_date =>
        bundle_inward__packing_date
          ? dayjs(bundle_inward__packing_date).format('DD-MM-YYYY')
          : 'N/A',
    },
    {
      title: 'Status',
      dataIndex: 'bundle_inward__status',
      key: 'bundle_inward__status',

      render: bundle_inward__status => bundle_inward__status || 'N/A',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Tooltip placement="top" title={'Print'}>
            <span onClick={() => handlePrint(record)}>
              <PrinterFilled style={{cursor: 'pointer'}} />
            </span>
          </Tooltip>
          <Link>
            <Tooltip title="Delete">
              <Popconfirm
                title="Are you sure you want to delete this bundle?"
                onConfirm={() => handleDelete(record?.id)} // Correctly access `id`
                onCancel={() => message.info('Action cancelled')}
                okText="Yes"
                cancelText="No"
              >
                <DeleteOutlined style={{cursor: 'pointer'}} />
              </Popconfirm>
            </Tooltip>
          </Link>
        </Space>
      ),
    },
  ];

  const handlePrint = data => {

    window.open(`/print-excess-stock/${data?.id}`, '_blank');
  };

  const handleDelete = id => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }
    dispatch(deleteExcessStock(id))
      .unwrap()
      .then(() => {
        message.success('Excess stock bundle deleted permanently!');
        dispatch(resetexcessStockList());
        dispatch(
          fetchExcessStockBundles({
            page,
            pagesize,
            ...(search && {search: search}),
            ...(orderBy && {ordering: orderBy}),
          }),
        );
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const filteredColumns = columns.filter(column =>
    checkedList.includes(column.key),
  );
  
  return (
   <div className='mainwrap'>
      <div className="sticyaction">
        <div className="pagenamerow">
          <h2>Create Excess Stock</h2>
          <div className="bredcrumbwrp">
            <Link to="/excess-stock" className="back">
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                {title: <Link to="/dashboard">Home</Link>},
                {title: <Link to="/excess-stock">Excess Stock</Link>},
                {title: 'Add New Excess Stock'},
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper" style={{overflow:'hidden'}}>
        <Row gutter={24} style={{height:'100%'}}>
          <Col xs={24} xl={6} style={{height:'100%'}}>
            <Form className='scrollform' layout="vertical" form={form} onFinish={handleFinish}>
              <Row gutter={16}>
                <Col xs={24}>
                  <Form.Item
                    label="Profile No"
                    name="die_profile"
                    rules={[
                      {required: true, message: 'Please select a Profile No'},
                    ]}
                  >
                    <AutoOpenSelect
                      placeholder="Select Profile No"
                      style={{width: '100%'}}
                      onChange={handleDieProfileChange}
                      onPopupScroll={onScrollDieProfile}
                      showSearch={true}
                      value={searchGroup}
                      onSearch={handleSearchDieGroup}
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      dropdownRender={menu => <>{menu}</>}
                    >
                      {[
                        ...new Map(
                          dieProfileList.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {el.die_number}
                        </Option>
                      ))}
                      {dieProfileLoading && <Option>Loading...</Option>}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item
                    label="Length"
                    name="length"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter length',
                      },
                      createNumberValidationRule({
                        allowNegative: false,
                        maxBeforeDecimal: 10, // Set max before decimal
                        maxAfterDecimal: 3, // Set max after decimal
                        allowDecimal: true,
                      }),
                    ]}
                  >
                    <Input placeholder="0.0" />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item
                    name="alloy"
                    label="Alloy"
                    rules={[{required: true, message: 'Please select alloy'}]}
                  >
                    <AutoOpenSelect
                      placeholder="Select Alloy"
                      style={{width: '100%'}}
                      loading={alloyLoading}
                      onPopupScroll={onScrollAlloy}
                      value={searchAlloy}
                      onChange={handleChangeAlloy}
                      onSearch={handleSearchAlloy}
                      allowClear
                      showSearch={true}
                      filterOption={(input, option) => {
                        if (!input) return true; // Show all options if input is empty
                        const optionText = (option?.children || '')
                          .toString()
                          .replace(/\s+/g, '')
                          .toLowerCase();
                        const inputText = input
                          .replace(/\s+/g, '')
                          .toLowerCase();
                        return optionText.includes(inputText);
                      }}
                      notFoundContent={
                        alloyLoading ? 'Loading...' : 'No options'
                      }
                      dropdownRender={menu => <>{menu}</>}
                    >
                      {[
                        ...new Map(
                          alloyList.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {el.name} - {el.color_code}
                        </Option>
                      ))}
                      {alloyLoading && <Option>Loading...</Option>}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item
                    name="temper"
                    label="Temper"
                    rules={[{required: true, message: 'Please select temper'}]}
                  >
                    <AutoOpenSelect
                      placeholder="Select Temper"
                      style={{width: '100%'}}
                      loading={temperLoading}
                      onPopupScroll={onScrollTemper}
                      value={searchTemper}
                      onChange={handleChangeTemper}
                      onSearch={handleSearchTemer}
                      allowClear
                      showSearch={true}
                      filterOption={(input, option) => {
                        if (!input) return true; // Show all options if input is empty
                        const optionText = (option?.children || '')
                          .toString()
                          .replace(/\s+/g, '')
                          .toLowerCase();
                        const inputText = input
                          .replace(/\s+/g, '')
                          .toLowerCase();
                        return optionText.includes(inputText);
                      }}
                      notFoundContent={
                        temperLoading ? 'Loading...' : 'No options'
                      }
                      dropdownRender={menu => <>{menu}</>}
                    >
                      {[
                        ...new Map(
                          temperList.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {el.name} - {el.code}
                        </Option>
                      ))}
                      {temperLoading && <Option>Loading...</Option>}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item
                    name="weight"
                    label="Weight"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter valid weight',
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter weight value"
                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({weight: formattedValue}); // Update Form state
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item
                    name="gross_weight"
                    label="Gross Weight"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter valid gross weight',
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter gross weight value"
                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({gross_weight: formattedValue}); // Update Form state
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item
                    name="pieces"
                    label="Pieces"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter valid pieces',
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter pieces"
                      maxLength={10}
                      onKeyPress={e => {
                        if (!/^[0-9]+$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({pieces: formattedValue}); // Update Form state
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={24}>
                  <Form.Item
                    label="Shift"
                    name="shift"
                    rules={[{required: true, message: 'Please select shift'}]}
                  >
                    <Select
                      disabled
                      placeholder="Select Shift"
                      onChange={handleChangeShift}
                      options={shiftModes}
                      value={selectedShift}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item
                    name="hardness_value"
                    label="Hardness Value"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter valid hardness value',
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter hardness value"
                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({hardness_value: formattedValue}); // Update Form state
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24}>
                  <Form.Item
                    name="remarks"
                    label="Remarks"
                    style={{marginLeft: '3px', marginTop: '10px'}}
                  >
                    <Input.TextArea
                      placeholder="Enter Remarks"
                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({remarks: formattedValue}); // Update Form state
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <div className="flex justify-end mb-3">
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<PlusOutlined />}
                >
                  Add Excess Stock
                </Button>
              </div>
            </Form>
          </Col>
          <Col xs={24} xl={18} style={{height:'100%', display:'flex'}}>
          <div className='tablewrp second'>
            <Table
              rowKey="id"
              columns={filteredColumns}
              dataSource={dataSource}
              pagination={{
                defaultCurrent: page,
                defaultPageSize: pagesize,
                total: totalRecord,
                showTotal: total => `Total ${total} items`,
                showSizeChanger: true,
                onChange: handlePageChange,
                locale: {
                  items_per_page: 'Items / Page', // Text for the size changer
                },
              }}
              onChange={handleTableChange}
              loading={status === 'loading'}
              scroll={{x: 1100}}
            />
            </div>
          </Col>
        </Row>
      </div>
   </div>
  );
}

export default CreateExcessStock;
